export const formatGameDateString = (
  isoDateString: string,
  shortYear = false,
) => {
  if (!isoDateString) return '';
  const date = new Date(isoDateString);
  return shortYear
    ? `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear().toString().slice(-2)}`
    : `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
};

// Format date for display on the page. YYYY on desktop, YY on mobile.
export const formatGameDate = (isoDateString: string) => {
  if (!isoDateString) return '';
  return (
    <>
      <div className="hidden lg:block">
        {formatGameDateString(isoDateString)}
      </div>
      <div className="block lg:hidden">
        {formatGameDateString(isoDateString, true)}
      </div>
    </>
  );
};
